
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiMenuAlt1 } from 'react-icons/hi';
import { GrClose } from 'react-icons/gr';

function Header() {
    const [open , setOpen ] = useState(false)
    
    
    return  <div className=" flex  pt-3 text-gray-600    items-center justify-between   ">
       {/* Logo */} 
       <div className=" p-2 p-l text-2xlr  font-semibold">
          <h1 className=" text-gray-500 text-2xl sm:text-center"><Link to="/" > Mahaer</Link> </h1> 



       </div>
        {/* large screen nav */}

        <div className="   sm:hidden hidden font-semibold md:flex items-center pt-1 shadowx  gap-6">
        <Link  to='/'> Home</Link>
        <Link  to="/projects"> Projects</Link>
        <Link  to='/about'> About</Link>
        <div className="hover:bg-slate-500 hover:text-white  rounded-lg font-medium hover:-translate-y-1 duration-200 px-2 "> 
            
        <Link  to='/contact'> Contact Us</Link>
        </div>
        </div>




        {/* mobile nav */}
     {/* <div className={' fixed top-0 z-50 bg-white w-60 h-screen shadow-2xl ${ open ? "right-0" : "right-[-100%]"} md:hidden flex flex-col space-y-10 font-medium text-gray-600 pt-20 p-7 duration-100'} > */}
        <div className={` fixed top-0 z-50 bg-white w-60 h-screen shadow-2xl ${ open ? "right-0" : "right-[-100%]" } md:hidden flex flex-col space-y-10 font-medium text-gray-600 pt-20 p-7 duration-100`}>
                 
        <Link  to=''> Home</Link>
        <Link  to='/projects'> Project</Link>
        <Link  to='/about'> About</Link>
        <div className="hover:bg-gray-300 p-1  rounded-lg font-medium hover:-translate-y-1 duration-200  w-20  "> 
              
        <Link  to='/contact'> Contact </Link> 
        </div>
        </div> 

        {/* /* toggle button */}

        <div className=" fixed right-[5%] md:hidden text-2xl  z-50" onClick={()=> setOpen(!open)}>
         
         {open ? (
         <GrClose className="h-7  cursor-pointer" />
         ): (
            <HiMenuAlt1 className="h-7  cursor-pointer"/>
         )
         }
        </div>
        </div>

}

export default Header;